<svg
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
  {...$$props}
>
  <g clip-path="url(#clip0_2185_64903)">
    <path
      d="M6 10.625C8.55432 10.625 10.625 8.55432 10.625 6C10.625 3.44568 8.55432 1.375 6 1.375M6 10.625C3.44568 10.625 1.375 8.55432 1.375 6C1.375 3.44568 3.44568 1.375 6 1.375M6 10.625C4.82639 10.625 3.875 8.55432 3.875 6C3.875 3.44568 4.82639 1.375 6 1.375M6 10.625C7.17361 10.625 8.125 8.55432 8.125 6C8.125 3.44568 7.17361 1.375 6 1.375M10.5 6H1.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </g>
  <defs>
    <clipPath id="clip0_2185_64903">
      <rect width="12" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>
